"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.string.trim.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SurveyMultipleOptionInput',
  props: {
    value: Array
  },
  methods: {
    handleAdd: function handleAdd() {
      this.value.push({
        value: '',
        label: ''
      });
    },
    handleRemove: function handleRemove(index) {
      this.value.splice(index, 1);
    },
    handleValueChange: function handleValueChange(item) {
      item.value = item.value.trim();
    },
    handleLabelChange: function handleLabelChange(item) {
      item.label = item.label.trim();
    }
  }
};